module.exports = __webpack_public_path__ + "static/media/connectring.15e0d25b.png";